import {
  queryExpressTemplateListApi,
  queryExpressTemplateByIdApi,
  updateExpressTemplateIsDefaultApi,
  updateExpressTemplateApi,
  deleteExpressTemplateApi,
  addExpressTemplateApi,
  getDistrictListApi,
  addDeliveryPriceConfigApi,
  queryDeliveryPriceConfigApi,
  deleteDeliveryPriceConfigApi,
  querySendExpressListApi,
  queryCollectExpressListApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  // 查询快递配置详情列表
  async queryExpressTemplateListAction(context, param) {
    const res = await queryExpressTemplateListApi(param)
    return res
  },
  // 查询快递配置对应id的详情信息
  async queryExpressTemplateByIdAction(context, param) {
    const res = await queryExpressTemplateByIdApi(param)
    return res
  },
  // 修改快递配置为默认
  async updateExpressTemplateIsDefaultAction(context, param) {
    const res = await updateExpressTemplateIsDefaultApi(param)
    return res
  },
  // 修改快递配置
  async updateExpressTemplateAction(context, param) {
    const res = await updateExpressTemplateApi(param)
    return res
  },
  // 删除快递配置
  async deleteExpressTemplateAction(context, param) {
    const res = await deleteExpressTemplateApi(param)
    return res
  },
  // 添加快递配置
  async addExpressTemplateAction(context, param) {
    const res = await addExpressTemplateApi(param)
    return res
  },
  // 城市信息
  async getDistrictListAction(context, param) {
    const res = await getDistrictListApi(param)
    return res
  },
  // 添加配送价格配置
  async addDeliveryPriceConfigActions(context, param) {
    const res = await addDeliveryPriceConfigApi(param)
    return res
  },
  // 查询配送价格配置列表
  async queryDeliveryPriceConfigActions(context, param) {
    const res = await queryDeliveryPriceConfigApi(param)
    return res
  },
  // 删除配送价格配置
  async deleteDeliveryPriceConfigActions(context, param) {
    const res = await deleteDeliveryPriceConfigApi(param)
    return res
  },
  // 查询预约寄件列表
  async querySendExpressListAction(context, param) {
    const res = await querySendExpressListApi(param)
    return res
  },
  // 查询预约取件列表
  async queryCollectExpressListAction(context, param) {
    const res = await queryCollectExpressListApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
